var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { ResourceTaskRunner } from './taskRunner';
export function createCacheEnhancer(config) {
    var enhancer = function (createStore) { return function (reducer) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var store = createStore.apply(void 0, __spread([reducer], args));
        var depth = 0;
        var processing = false;
        var pendingTasks;
        var taskQueue = {};
        var taskQueueIds;
        var dispatch = function (action) {
            ++depth;
            store.dispatch(action);
            --depth;
            // The `dispatch` function calls any listeners before completing, which
            // can in turn recursively call `dispatch`. With this in mind, let's wait
            // until the initial dispatch completes before processing any tasks.
            if (depth === 0) {
                var state = store.getState();
                pendingTasks = state.tasks.pending;
                taskQueue = __assign(__assign({}, taskQueue), state.tasks.queue);
                taskQueueIds = Object.keys(taskQueue);
                if (taskQueueIds.length) {
                    store.dispatch({ type: 'clearQueue' });
                }
                // Tasks/effects can synchronously dispatch further actions, and we only
                // want to process those jobs on the outermost dispatch.
                if (!processing) {
                    processing = true;
                    while (taskQueueIds.length) {
                        // Run a task
                        var taskId = taskQueueIds.shift();
                        var task = pendingTasks[taskId];
                        var queueType = taskQueue[taskId];
                        delete taskQueue[taskId];
                        if (task && queueType === 'start') {
                            taskRunner.start(task);
                        }
                        else {
                            // Just stop paused tasks for now.
                            taskRunner.stop(taskId);
                        }
                    }
                    processing = false;
                }
            }
        };
        var taskRunner = new ResourceTaskRunner(config.tasks, dispatch);
        return __assign(__assign({}, store), { dispatch: dispatch });
    }; };
    return enhancer;
}
//# sourceMappingURL=cacheEnhancer.js.map